<template>
	<div class="ezuikit">
		<div class="ezuikitjs">
			<EZUIKitJs :equipmentNo="selectvalue" :equipmentRoute="1" :ysyw="420" :ysyh="280" />
		</div>
		<div class="ezuikit-select">
				<select @change="Onchanges">
					<option value="E32557273">大棚1</option>
					<option value="E11004620">室内</option>
				</select>
		</div>
	</div>
</template>

<script lang="js" setup>
	
	import { ref,watch } from 'vue';
	let selectvalue=ref('E32557273')
    import EZUIKitJs from '@/components/ezuikit/EZUIKitJs.vue'
	function Onchanges(e){
		selectvalue.value=e.target.value;
	}
</script>

<style lang="scss">
.ezuikit{
	width: 420px;
	height: 280px;
	position: relative;
	.ezuikit-select{
		position: absolute;
		top: 8px;
		right: 30px;
		
		select{
			background-color: black;
			color: white;
			font-size: 12px;
			border: 0px;
		}
	}
}
</style>